import React from 'react';
import ModalTypeEnum from 'Modals/ModalConstants';
import BaseModal from 'Modals/BaseModal';
import PropTypes from 'prop-types';
import PublishTemplateModalBody from './PublishTemplateModalBody';

export default class PublishTemplateConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.makePublic = this.makePublic.bind(this);
  }

  makePublic() {
    window._track('Publish Now | Share Link', 'Template Builder');
    this.props.publish(this.props.documentType, true);
    this.props.close();
  }

  render() {
    return (
      <BaseModal
        modalType={ModalTypeEnum.SELF_SERVE_PUBLISH_TEMPLATE_CONFIRM}
        activeModal={this.props.activeModal}
        isOpen={this.props.isOpen}
        closeModal={this.props.close}
        includeHeaderCloseButton
        bodyContent={
          <PublishTemplateModalBody
            onCancel={this.props.close}
            onPublish={this.makePublic}
          />
        }
      />
    );
  }
}

PublishTemplateConfirmationModal.defaultProps = {
  activeModal: '',
};

PublishTemplateConfirmationModal.propTypes = {
  activeModal: PropTypes.oneOf([
    ModalTypeEnum.SELF_SERVE_ADD_RECIPIENTS_CONFIRM,
    ModalTypeEnum.SELF_SERVE_PUBLISH_TEMPLATE_CONFIRM,
    '',
  ]),
  close: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  publish: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/PublishTemplateConfirmationModal/index.jsx